import React, { ComponentType, Suspense } from "react";
import ServerSideService from "../../utilities/serverSideService";
import { INotificationProps } from "./notifications";

const Notifications = React.lazy(
  () =>
    import(
      /* webpackMode: "eager" */
      /* webpackChunkName: "slide-outs" */
      "./notifications"
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) as unknown as Promise<{ default: ComponentType<any> }>
);

const NotificationsWrapper = (props: INotificationProps) => {
  return (
    <>
      {ServerSideService.isServerSide ? undefined : (
        <Suspense fallback={<></>}>
          <Notifications {...props} />
        </Suspense>
      )}
    </>
  );
};

export default NotificationsWrapper;
